export default {
  namespaced: true,

  state: {
    elementSidebar: true,
  },

  mutations: {
    toggleElementSidebar(state, payload) {
      state.elementSidebar = payload
      localStorage.setItem('elementSidebar', payload)
    },
  },
  getters: {
    elementSidebar: state => state.elementSidebar,
  }
}